/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
// document event listeners
let isDocumentScrolled = false;
document.addEventListener('scroll', () => {
    //assure to trigger just once
    if (!isDocumentScrolled) {
        isDocumentScrolled = true;
        //here for core web vitals reasons
        initMapScript();
        initIubendaProof();
        initRecaptcha();
    }
});
const cardsAnimationTiming = 400;
window.addEventListener('load', (event) => {
    //document.addEventListener('DOMContentLoaded', (event) => {
    const formValidation = new FormsValidation();
    formValidation.initFormsValidation();
    initModalResponse();
    initLoadMore();
    initFilter();
    initVideo();
    initToggler();
    initMouseOverToggler();
    initCardComponent();
    initCardListTextCta();
    initFadeInAnimations();
    initBigSliderHeading();
    initGallery();
    initSelectorDistributors();
    initHeadingWithCard();
    initLatestBlogArticles();
    initScroll();
    initFilterSearch();
    initListingWidthFilters();
    initMappedImage();
    initImageVideoGallery();
    initSidebar();
    initHighlightSidebarOnScroll();
    initTableOfVariants();
    initCardSliderAndBanner();
    twoBlockGridWithAccordion();
    initPagesSlider();
    initProductPagesSlider();
    initLinePagesSlider();
    initImageTextWithCard();
    initAttachedFile();
    initRetriveYTPreview();
    initModalPDF();
    //@ts-ignore
    imageMapResize();
});
